<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>سؤال الجمهور</h2>
            <!--<p>الخطوة الثانية: بيانات الطالب</p>-->
        </div>
    </div>
</div>

<div class="service-details ptb-100">
    <div class="container">
        <div class="row align-items-center">




            <div class="">
                <div class="content left-content">


                    <form novalidate autocomplete="off" #form="ngForm" (ngSubmit)="onClick(answer1.checked,answer2.checked,answer3.checked,answer4.checked, fullName.value,phoneNo.value, address.value)">
                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <h4>{{ question }}</h4>
                            </div>


                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 form-group" style="margin-top:10px;">
                                <input type="radio" name="answer" #answer1 id="answer1" style="margin-left:10px;" />
                                <label for="answer1" style="margin-bottom: 10px;">{{ answers1 }}</label>

                            </div>
                            <div class="col-lg-6 col-md-6 form-group" style="margin-top:10px;">
                                <input type="radio" name="answer" #answer2 id="answer2" style="margin-left:10px;" />
                                <label for="answer2" style="margin-bottom: 10px;">{{ answers2 }}</label>

                            </div>
                            <div class="col-lg-6 col-md-6 form-group" style="margin-top:10px;">
                                <input type="radio" name="answer" #answer3 id="answer3" style="margin-left:10px;" />
                                <label for="answer3" style="margin-bottom: 10px;">{{ answers3 }}</label>

                            </div>
                            <div class="col-lg-6 col-md-6 form-group"  style="margin-top:10px;">
                                <input type="radio" name="answer" #answer4 id="answer4" style="margin-left:10px;" />
                                <label for="answer4" style="margin-bottom:10px;">{{ answers4 }}</label>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12 col-md-12 form-group">
                                <br />
                                <label>الاسم الثلاثي والقبيلة</label>
                                <input class="form-control form-control-lg" #fullName name="fullName" required>
                            </div>
                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>رقم الهاتف</label>
                                <input class="form-control form-control-lg" #phoneNo name="phoneNo" required>
                            </div>

                            <div class="col-lg-6 col-md-6 form-group">
                                <br />
                                <label>العنوان</label>
                                <input class="form-control form-control-lg" #address name="address" required>
                            </div>
                        </div>

                            <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <br />
                                    <button class="default-btn" name="submit_button" ><i class='bx bxs-paper-plane'></i>إرسال<span></span></button>
                                </div>
                            </div>
                    </form>


                </div>

                </div>
        </div>


    </div>
</div>

